var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavmenubluesvg = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.416504 2.0835H19.5832V4.5835H0.416504V2.0835Z",
    fill: "#1D6460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.416504 8.75H19.5832V11.25H0.416504V8.75Z",
    fill: "#1D6460"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.416504 15.417H19.5832V17.917H0.416504V15.417Z",
    fill: "#1D6460"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavmenubluesvg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/navmenubluesvg.11984de10dd00a4a9658c2affae384e2.svg";